import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import { e工程区分 } from "../../../constant/enum/zyutuHaisya"
import { T傭車マスタ } from "../../../service/master/yosya/TYosya"
import SyaryoService from "../../../service/truck/syaryoService"
import { 全部所車番検索Enabled } from "../../../constant/featureFlags"
import {
  T品名情報,
  T積卸情報,
} from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import {
  TSyaryoListGetReq,
  TSyaryoModalList,
} from "../../../service/truck/TSyaryo"
import { abstractSelectItemWhenLostFocusHandler } from "../../../ts/util/autoCompleteUtil"
import {
  getSyaryoItemsSource,
  getYosyaItemsSource,
} from "../../../ts/util/haisyaUtil"

export type T積卸情報Grid = Partial<T積卸情報> & {
  row_id: Symbol
}

export type T品名情報Grid = Partial<T品名情報> & {
  工程区分コード?: string
  row_id: Symbol
}

export type T請求支払情報Grid = {
  種別: string
  運送料課税区分コード?: string
  運送料金額: number | undefined
  付帯料課税区分コード?: string
  付帯料金額: number | undefined
  高速料金税込区分コード?: string
  高速料金額: number | undefined
  AGC高速料マスタID?: number
  高速料記号?: string
  備考: string
}

/**
 * 積卸情報先頭行判別
 * @param grid
 * @param row_id
 * @returns
 */
export const isFirstRow = (grid: wjcGrid.FlexGrid, row_id: Symbol): boolean => {
  // 工程No.1でもっとも先頭の行の場合削除不能とする
  const itemsSource = grid.itemsSource as wjCore.CollectionView
  const sourceCollection = itemsSource.sourceCollection as T積卸情報Grid[]
  if (sourceCollection == null) return false
  const firstItem = sourceCollection.find(
    (d) => d.工程順 === 1 && d.工程区分コード === e工程区分.積
  )
  return firstItem != null && firstItem.row_id === row_id
}

/**
 * 同一内容の工程情報であるかの確認用メソッド
 * 前提として分割受注配車の積受注と卸受注の比較のため、工程順で確認すれば必要十分
 * @param 積受注配車側
 * @param 卸受注配車側
 * @returns
 */
export const isSame工程 = (
  積受注配車側工程: T積卸情報,
  卸受注配車側工程: T積卸情報
) => {
  return 積受注配車側工程.工程順 === 卸受注配車側工程.工程順
}

/**
 * 同一内容の積載品情報であるかの確認用メソッド
 * @param 積受注配車側積載品
 * @param 卸受注配車側積載品
 * @returns
 */
export const isSame積載品 = (
  積受注配車側積載品: T品名情報,
  卸受注配車側積載品: T品名情報
) => {
  return (
    積受注配車側積載品.品コード === 卸受注配車側積載品.品コード &&
    積受注配車側積載品.品名 === 卸受注配車側積載品.品名 &&
    積受注配車側積載品.数量 === 卸受注配車側積載品.数量 &&
    積受注配車側積載品.単位区分コード === 卸受注配車側積載品.単位区分コード &&
    積受注配車側積載品.単価 === 卸受注配車側積載品.単価 &&
    積受注配車側積載品.工程順 === 卸受注配車側積載品.工程順 &&
    積受注配車側積載品.運送料 === 卸受注配車側積載品.運送料 &&
    積受注配車側積載品.付帯料 === 卸受注配車側積載品.付帯料
  )
}

/**
 * 稼働掛率区分コードの存在を確認し、なかった場合車輌IDより取得する
 * @param 稼働掛率区分コード
 * @param 車輌ID
 * @returns
 */
export const 稼働掛率区分コード取得By車輌 = async (
  稼働掛率区分コード: string | null | undefined,
  車輌ID: number | null | undefined
) => {
  // 稼働掛率区分コードが空の場合、車輌より取得して登録
  if (稼働掛率区分コード == null || 稼働掛率区分コード === "") {
    try {
      if (車輌ID) {
        const 車輌Res = await new SyaryoService().get(車輌ID)
        if (車輌Res.data) {
          return 車輌Res.data.稼働手当車種掛率区分コード
        }
      }
      return ""
    } catch (error) {
      throw error
    }
  } else {
    return 稼働掛率区分コード
  }
}

// MEMO: カリー化により外部からsetStateをもらう処理となっているので注意

/**
 * 車輌オートコンプリートFocusハンドラ
 * @param pre車番Ref
 * @param 運行部所コードRef
 * @param 傭車コードRef
 * @param 原動機有無
 * @returns
 */
export const 車輌GotFocusHandler =
  (
    pre車番Ref: React.MutableRefObject<string | null | undefined>,
    運行部所コードRef: React.MutableRefObject<string | undefined>,
    傭車コードRef: React.MutableRefObject<string | undefined>,
    原動機有無: 0 | 1
  ) =>
  (control: wjcInput.AutoComplete) => {
    pre車番Ref.current = control.text
    if (傭車コードRef.current != null && 傭車コードRef.current !== "") {
      control.isEditable = true
      control.itemsSourceFunction = getYosyaItemsSource(傭車コードRef)
    } else {
      control.isEditable = false
      control.itemsSourceFunction = getSyaryoItemsSource(
        運行部所コードRef,
        原動機有無
      )
    }
  }

/**
 * 車輌autoCompleteのフォーカスアウト時のハンドラ
 * @param pre車番Ref
 * @param 運行部所コードRef
 * @param 傭車コードRef
 * @param set傭車ID
 * @param set車輌ID
 * @param set車番
 * @param set車種区分名称
 * @param set稼働掛率区分コード
 * @param setトレーラ車輌ID
 * @param setトレーラ車番
 * @param setトレーラ車種区分名称
 * @param set乗務員ID
 * @param set乗務員コード
 * @param set乗務員名
 * @param setIsSyaryoLostFocus
 * @returns
 */
export const 車輌LostFocusHandler =
  (
    pre車番Ref: React.MutableRefObject<string | null | undefined>,
    運行部所コードRef: React.MutableRefObject<string | undefined>,
    傭車コードRef: React.MutableRefObject<string | undefined>,
    set傭車ID: React.Dispatch<React.SetStateAction<number | null | undefined>>,
    set車輌ID: React.Dispatch<React.SetStateAction<number | null | undefined>>,
    set車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    set車種区分名称: React.Dispatch<React.SetStateAction<string | undefined>>,
    set稼働掛率区分コード: React.Dispatch<
      React.SetStateAction<string | null | undefined>
    >,
    set最大積載量: React.Dispatch<React.SetStateAction<number | undefined>>,
    setトレーラ車輌ID: React.Dispatch<
      React.SetStateAction<number | null | undefined>
    >,
    setトレーラ車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    setトレーラ車種区分名称: React.Dispatch<
      React.SetStateAction<string | undefined>
    >,
    setトレーラ最大積載量: React.Dispatch<
      React.SetStateAction<number | undefined>
    >,
    set乗務員ID: React.Dispatch<React.SetStateAction<number | undefined>>,
    set乗務員コード: React.Dispatch<React.SetStateAction<string | undefined>>,
    set乗務員名: React.Dispatch<React.SetStateAction<string | undefined>>,
    setIsSyaryoLostFocus: React.Dispatch<React.SetStateAction<boolean>>
  ) =>
  (control: wjcInput.AutoComplete) => {
    if (傭車コードRef.current != null && 傭車コードRef.current !== "") {
      if (!control.selectedItem) {
        set傭車ID(undefined)
        set車輌ID(undefined)
        set車番(control.text ?? undefined)
        set車種区分名称("")
        set最大積載量(undefined)
        return
      }
      const 傭車: T傭車マスタ = control.selectedItem
      set傭車ID(傭車.傭車ID)
      set車輌ID(undefined)
      set車番(傭車.車番)
      set車種区分名称(傭車.車種区分名称1)
      set乗務員ID(undefined)
      set乗務員コード(undefined)
      set乗務員名(傭車.乗務員名)
      setIsSyaryoLostFocus(true)
      return
    }
    abstractSelectItemWhenLostFocusHandler<TSyaryoModalList>(
      control,
      cast車輌データ(
        pre車番Ref,
        set車輌ID,
        set車番,
        set車種区分名称,
        set稼働掛率区分コード,
        set最大積載量,
        setトレーラ車輌ID,
        setトレーラ車番,
        setトレーラ車種区分名称,
        setトレーラ最大積載量,
        set乗務員ID,
        set乗務員コード,
        set乗務員名
      ),
      () => {
        if (control.text) {
          syaryoSearch(
            運行部所コードRef,
            set車輌ID,
            set車番,
            set車種区分名称,
            set稼働掛率区分コード,
            set最大積載量,
            setトレーラ車輌ID,
            setトレーラ車番,
            setトレーラ車種区分名称,
            setトレーラ最大積載量,
            set乗務員ID,
            set乗務員コード,
            set乗務員名,
            setIsSyaryoLostFocus
          )(control.text, control)
        } else {
          set車輌ID(undefined)
          set車番("")
          set車種区分名称("")
          set稼働掛率区分コード("")
          set最大積載量(undefined)
        }
      }
    )
    setIsSyaryoLostFocus(true)
  }

/**
 * 車輌フォーカスアウト時の検索
 * @param 運行部所コードRef
 * @param set車輌ID
 * @param set車番
 * @param set車種区分名称
 * @param set稼働掛率区分コード
 * @param setトレーラ車輌ID
 * @param setトレーラ車番
 * @param setトレーラ車種区分名称
 * @param set乗務員ID
 * @param set乗務員コード
 * @param set乗務員名
 * @param setIsSyaryoLostFocus
 * @returns
 */
export const syaryoSearch =
  (
    運行部所コードRef: React.MutableRefObject<string | undefined>,
    set車輌ID: React.Dispatch<React.SetStateAction<number | null | undefined>>,
    set車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    set車種区分名称: React.Dispatch<React.SetStateAction<string | undefined>>,
    set稼働掛率区分コード: React.Dispatch<
      React.SetStateAction<string | null | undefined>
    >,
    set最大積載量: React.Dispatch<React.SetStateAction<number | undefined>>,
    setトレーラ車輌ID: React.Dispatch<
      React.SetStateAction<number | null | undefined>
    >,
    setトレーラ車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    setトレーラ車種区分名称: React.Dispatch<
      React.SetStateAction<string | undefined>
    >,
    setトレーラ最大積載量: React.Dispatch<
      React.SetStateAction<number | undefined>
    >,
    set乗務員ID: React.Dispatch<React.SetStateAction<number | undefined>>,
    set乗務員コード: React.Dispatch<React.SetStateAction<string | undefined>>,
    set乗務員名: React.Dispatch<React.SetStateAction<string | undefined>>,
    setIsSyaryoLostFocus: React.Dispatch<React.SetStateAction<boolean>>
  ) =>
  async (車番: string, control: wjcInput.AutoComplete) => {
    const syaryoService = new SyaryoService()
    const syaryoCondition: TSyaryoListGetReq = {
      車番: 車番,
      部所コード: 全部所車番検索Enabled ? undefined : 運行部所コードRef.current,
      原動機有無フラグ: 1,
    }
    const res = await syaryoService.getList(syaryoCondition)
    const exactMatches = res.data.filter((d) => d.車番 === 車番)
    if (exactMatches.length === 1) {
      const ヘッド車輌 = exactMatches[0]
      set車輌ID(ヘッド車輌.車輌ID)
      set車番(ヘッド車輌.車番)
      set車種区分名称(ヘッド車輌.車種区分名称1)
      set稼働掛率区分コード(ヘッド車輌.稼働手当車種別掛率区分コード)
      set最大積載量(ヘッド車輌.最大積載量)
      // トレーラのデータも存在する場合、そちらも登録する
      if (ヘッド車輌.トレーラ車輌ID) {
        setトレーラ車輌ID(ヘッド車輌.トレーラ車輌ID)
        setトレーラ車番(ヘッド車輌.トレーラ車番)
        setトレーラ車種区分名称(ヘッド車輌.トレーラ車種区分名称1)
        setトレーラ最大積載量(ヘッド車輌.トレーラ最大積載量)
      }
      // 乗務員も登録されていた場合、そちらも登録する
      if (ヘッド車輌.乗務員ID) {
        set乗務員ID(ヘッド車輌.乗務員ID)
        set乗務員コード(ヘッド車輌.社員コード)
        set乗務員名(ヘッド車輌.社員氏名)
      }

      setIsSyaryoLostFocus(true)
    } else {
      set車輌ID(undefined)
      set車番("")
      set車種区分名称("")
      set稼働掛率区分コード("")
      set最大積載量(undefined)
      control.text = ""
    }
  }

/**
 * ヘッド車輌用のstateへのキャスト関数
 * @param pre車番Ref
 * @param set車輌ID
 * @param set車番
 * @param set車種区分名称
 * @param set稼働掛率区分コード
 * @param setトレーラ車輌ID
 * @param setトレーラ車番
 * @param setトレーラ車種区分名称
 * @param set乗務員ID
 * @param set乗務員コード
 * @param set乗務員名
 * @returns
 */
const cast車輌データ =
  (
    pre車番Ref: React.MutableRefObject<string | null | undefined>,
    set車輌ID: React.Dispatch<React.SetStateAction<number | null | undefined>>,
    set車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    set車種区分名称: React.Dispatch<React.SetStateAction<string | undefined>>,
    set稼働掛率区分コード: React.Dispatch<
      React.SetStateAction<string | null | undefined>
    >,
    set最大積載量: React.Dispatch<React.SetStateAction<number | undefined>>,
    setトレーラ車輌ID: React.Dispatch<
      React.SetStateAction<number | null | undefined>
    >,
    setトレーラ車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    setトレーラ車種区分名称: React.Dispatch<
      React.SetStateAction<string | undefined>
    >,
    setトレーラ最大積載量: React.Dispatch<
      React.SetStateAction<number | undefined>
    >,
    set乗務員ID: React.Dispatch<React.SetStateAction<number | undefined>>,
    set乗務員コード: React.Dispatch<React.SetStateAction<string | undefined>>,
    set乗務員名: React.Dispatch<React.SetStateAction<string | undefined>>
  ) =>
  (ヘッド車輌: TSyaryoModalList, control?: wjcInput.AutoComplete) => {
    // 変更がない場合処理しない。
    if (control?.text === pre車番Ref.current) return
    set車輌ID(ヘッド車輌.車輌ID)
    set車番(ヘッド車輌.車番)
    set車種区分名称(ヘッド車輌.車種区分名称1)
    set稼働掛率区分コード(ヘッド車輌.稼働手当車種別掛率区分コード)
    set最大積載量(ヘッド車輌.最大積載量)
    // トレーラのデータも存在する場合、そちらも登録する
    if (ヘッド車輌.トレーラ車輌ID) {
      setトレーラ車輌ID(ヘッド車輌.トレーラ車輌ID)
      setトレーラ車番(ヘッド車輌.トレーラ車番)
      setトレーラ車種区分名称(ヘッド車輌.トレーラ車種区分名称1)
      setトレーラ最大積載量(ヘッド車輌.トレーラ最大積載量)
    }
    // 乗務員も登録されていた場合、そちらも登録する
    if (ヘッド車輌.乗務員ID) {
      set乗務員ID(ヘッド車輌.乗務員ID)
      set乗務員コード(ヘッド車輌.社員コード)
      set乗務員名(ヘッド車輌.社員氏名)
    }
  }

/**
 * トレーラ車輛AutoCompleteのフォーカスアウト時のハンドラ
 * @param preトレーラ車番Ref
 * @param setトレーラ車輌ID
 * @param setトレーラ車番
 * @param setトレーラ車種区分名称
 * @param setIsSyaryoLostFocus
 * @returns
 */
export const トレーラ車輛LostFocus =
  (
    傭車コードRef: React.MutableRefObject<string | null | undefined>,
    preトレーラ車番Ref: React.MutableRefObject<string | null | undefined>,
    setトレーラ車輌ID: React.Dispatch<
      React.SetStateAction<number | null | undefined>
    >,
    setトレーラ車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    setトレーラ車種区分名称: React.Dispatch<
      React.SetStateAction<string | undefined>
    >,
    setトレーラ最大積載量: React.Dispatch<
      React.SetStateAction<number | undefined>
    >,
    setIsSyaryoLostFocus: React.Dispatch<React.SetStateAction<boolean>>,
    運行部所コードRef?: React.MutableRefObject<string | undefined>
  ) =>
  (control: wjcInput.AutoComplete) => {
    if (傭車コードRef.current != null && 傭車コードRef.current !== "") {
      if (!control.selectedItem) {
        setトレーラ車輌ID(undefined)
        setトレーラ車番(control.text ?? undefined)
        setトレーラ車種区分名称("")
        return
      }
      const 傭車: T傭車マスタ = control.selectedItem
      setトレーラ車輌ID(undefined)
      setトレーラ車番(傭車.車番)
      setトレーラ車種区分名称(傭車.車種区分名称1)
      setIsSyaryoLostFocus(true)
      return
    }
    abstractSelectItemWhenLostFocusHandler<TSyaryoModalList>(
      control,
      (ヘッド車輌) => {
        // 選択できた場合はテキストに変更がない場合はデータを入れ替えない
        if (control.text === preトレーラ車番Ref.current) return
        setトレーラ車輌ID(ヘッド車輌.車輌ID)
        setトレーラ車番(ヘッド車輌.車番)
        setトレーラ車種区分名称(ヘッド車輌.車種区分名称1)
        setトレーラ最大積載量(ヘッド車輌.最大積載量)
        setIsSyaryoLostFocus(true)
      },
      () => {
        if (control.text) {
          // テキストに変更がない場合特に処理せずスルー
          if (preトレーラ車番Ref.current === control.text) {
            setIsSyaryoLostFocus(true)
            return
          }
          trailerSyaryoSearch(
            setトレーラ車輌ID,
            setトレーラ車番,
            setトレーラ車種区分名称,
            setトレーラ最大積載量,
            setIsSyaryoLostFocus,
            運行部所コードRef
          )(control.text, control)
        } else {
          setトレーラ車輌ID(undefined)
          setトレーラ車番("")
          setトレーラ車種区分名称("")
          setトレーラ最大積載量(undefined)
        }
      }
    )
    setIsSyaryoLostFocus(true)
  }

/**
 * トレーラ車輌フォーカスアウト時の検索
 * @param setトレーラ車輌ID
 * @param setトレーラ車番
 * @param setトレーラ車種区分名称
 * @param setIsSyaryoLostFocus
 * @param 運行部所コードRef - 全部所車番検索Enabled=false 時のみ使用
 * @returns
 */
export const trailerSyaryoSearch =
  (
    setトレーラ車輌ID: React.Dispatch<
      React.SetStateAction<number | null | undefined>
    >,
    setトレーラ車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    setトレーラ車種区分名称: React.Dispatch<
      React.SetStateAction<string | undefined>
    >,
    setトレーラ最大積載量: React.Dispatch<
      React.SetStateAction<number | undefined>
    >,
    setIsSyaryoLostFocus: React.Dispatch<React.SetStateAction<boolean>>,
    運行部所コードRef?: React.MutableRefObject<string | undefined>
  ) =>
  async (車番: string, control: wjcInput.AutoComplete) => {
    const syaryoService = new SyaryoService()
    if (!全部所車番検索Enabled && 運行部所コードRef?.current == null) {
      setトレーラ車輌ID(undefined)
      setトレーラ車番("")
      setトレーラ車種区分名称("")
      setトレーラ最大積載量(undefined)
      setIsSyaryoLostFocus(true)
      return
    }
    const syaryoCondition: TSyaryoListGetReq = {
      車番: 車番,
      部所コード: 全部所車番検索Enabled ? undefined : 運行部所コードRef?.current,
      原動機有無フラグ: 0,
    }
    const res = await syaryoService.getList(syaryoCondition)
    const exactMatches = res.data.filter((d) => d.車番 === 車番)
    if (exactMatches.length === 1) {
      const 車輌 = exactMatches[0]
      setトレーラ車輌ID(車輌.車輌ID)
      setトレーラ車番(車輌.車番)
      setトレーラ車種区分名称(車輌.車種区分名称1)
      setトレーラ最大積載量(車輌.最大積載量)
      setIsSyaryoLostFocus(true)
    } else {
      setトレーラ車輌ID(undefined)
      setトレーラ車番("")
      setトレーラ車種区分名称("")
      setトレーラ最大積載量(undefined)
      setIsSyaryoLostFocus(true)
    }
  }

/**
 * 車輌Modal情報登録用の関数
 */
export const set車輌情報ByModalInner =
  (
    車輌検索用原動機有無フラグ: 0 | 1 | undefined,
    set車輌ID: React.Dispatch<React.SetStateAction<number | null | undefined>>,
    set車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    set車種区分名称: React.Dispatch<React.SetStateAction<string | undefined>>,
    set最大積載量: React.Dispatch<React.SetStateAction<number | undefined>>,
    setトレーラ車輌ID: React.Dispatch<
      React.SetStateAction<number | null | undefined>
    >,
    setトレーラ車番: React.Dispatch<React.SetStateAction<string | undefined>>,
    setトレーラ車種区分名称: React.Dispatch<
      React.SetStateAction<string | undefined>
    >,
    setトレーラ最大積載量: React.Dispatch<
      React.SetStateAction<number | undefined>
    >,
    set乗務員ID: React.Dispatch<React.SetStateAction<number | undefined>>,
    set乗務員コード: React.Dispatch<React.SetStateAction<string | undefined>>,
    set乗務員名: React.Dispatch<React.SetStateAction<string | undefined>>,
    set稼働掛率区分コード: React.Dispatch<
      React.SetStateAction<string | null | undefined>
    >
  ) =>
  (車輌: TSyaryoModalList) => {
    switch (車輌検索用原動機有無フラグ) {
      case 1:
        // 有 車輌
        set車輌ID(車輌.車輌ID)
        set車番(車輌.車番)
        set車種区分名称(車輌.車種区分名称1)
        set最大積載量(車輌.最大積載量)
        set乗務員ID(車輌.乗務員ID)
        set乗務員コード(車輌.社員コード)
        set乗務員名(車輌.社員氏名)
        if (車輌.トレーラ車輌ID) {
          setトレーラ車輌ID(車輌.トレーラ車輌ID)
          setトレーラ車番(車輌.トレーラ車番)
          setトレーラ車種区分名称(車輌.トレーラ車種区分名称1)
          setトレーラ最大積載量(車輌.トレーラ最大積載量)
        }
        // 稼働掛率を設定する
        set稼働掛率区分コード(車輌.稼働手当車種別掛率区分コード)
        break
      case 0:
        // 無 トレーラ車輌
        //トレーラ車輌
        setトレーラ車輌ID(車輌.車輌ID)
        setトレーラ車番(車輌.車番)
        setトレーラ車種区分名称(車輌.車種区分名称1)
        setトレーラ最大積載量(車輌.最大積載量)

        break
      default:
        break
    }
  }

/**
 * 車番のvalidate用関数
 * @param 車輌ID
 * @param 車番
 * @param set車輌ID
 * @param setIsInvalid車番
 * @param トレーラ車輌ID
 * @param トレーラ車番
 * @param setトレーラ車輌ID
 * @param setIsInvalidトレーラ車番
 * @returns
 */
export const 車番validate =
  (
    車輌ID: number | null | undefined,
    車番: string | null | undefined,
    set車輌ID: React.Dispatch<React.SetStateAction<number | null | undefined>>,
    setIsInvalid車番: React.Dispatch<React.SetStateAction<boolean>>,
    トレーラ車輌ID: number | null | undefined,
    トレーラ車番: string | null | undefined,
    setトレーラ車輌ID: React.Dispatch<
      React.SetStateAction<number | null | undefined>
    >,
    setIsInvalidトレーラ車番: React.Dispatch<React.SetStateAction<boolean>>,
    部所コード: string | null | undefined
  ) =>
  async () => {
    let 車番エラー = false
    const エラーメッセージList: string[] = []

    // 車番
    if (
      車輌ID == null &&
      車番 != null &&
      !wjCore.isNullOrWhiteSpace(車番 ?? "")
    ) {
      const { id: 対象車輌id, error: 対象車輌error } = await canGet車輌(
        車番,
        部所コード
      )

      if (対象車輌id) {
        set車輌ID(対象車輌id)
      } else {
        車番エラー = true
        if (対象車輌error === "重複") {
          エラーメッセージList.push("車番に該当する車輌が複数存在します。")
        } else {
          エラーメッセージList.push("車番に該当する車輌が存在しません")
        }
        setIsInvalid車番(true)
      }
    }
    // トレーラ車番
    if (
      トレーラ車輌ID == null &&
      トレーラ車番 != null &&
      !wjCore.isNullOrWhiteSpace(トレーラ車番 ?? "")
    ) {
      const { id: 対象トレーラ車輌id, error: トレーラ対象車輌error } =
        await canGet車輌(トレーラ車番, 部所コード)

      if (対象トレーラ車輌id) {
        setトレーラ車輌ID(対象トレーラ車輌id)
      } else {
        車番エラー = true
        if (トレーラ対象車輌error === "重複") {
          エラーメッセージList.push(
            "トレーラ車番に該当する車輌が複数存在します。"
          )
        } else {
          エラーメッセージList.push("トレーラ車番に該当する車輌が存在しません")
        }
        setIsInvalidトレーラ車番(true)
      }
    }

    return { hasError: 車番エラー, messages: エラーメッセージList }
  }

/**
 * 車番のみで検索し、一件のみ車輌が取得できるかチェックする
 */
const canGet車輌 = async (
  車番: string,
  部所コード: string | null | undefined
) => {
  try {
    const res = await new SyaryoService().getList({
      車番,
      部所コード: 部所コード ?? undefined,
    })
    if (res && res.data) {
      const exactMatches = res.data.filter((d) => d.車番 === 車番)
      if (exactMatches.length > 1) {
        return { id: null, error: "重複" }
      } else if (exactMatches.length < 1) {
        return { id: null, error: "未存在" }
      } else {
        return { id: exactMatches[0].車輌ID, error: null }
      }
    }
    return { id: null, error: "未存在" }
  } catch (error) {
    return { id: null, error: "未存在" }
  }
}
